import { FC, ReactNode } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Paper, SxProps, Theme } from '@mui/material'

import { ErrorFallback } from '@components/ErrorFallback'

import { FLEXIBLE } from '@constants'

type PageContentLayoutProps = {
  children: ReactNode
  hidden?: boolean
  isBreadcrumbs?: boolean
  height?: number | string
  sx?: SxProps<Theme>
}

export const PageContentLayout: FC<PageContentLayoutProps> = ({
  children,
  hidden,
  isBreadcrumbs,
  sx,
  ...props
}) => {
  if (hidden) {
    return <>{children}</>
  }

  const height = props.height || '100%'

  return (
    <Paper
      variant='outlined'
      sx={{
        height,
        ...FLEXIBLE,
        // borderRadius: 0,
        border: theme => theme.palette.border.paper,
        ...sx,
      }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
    </Paper>
  )
}
